// extracted by mini-css-extract-plugin
export default {"flippingArrowWrapper":"flippingArrow_flippingArrowWrapper__Fdsgm","flippingArrow":"flippingArrow_flippingArrow__+2HzZ"};